import SharedToolbar from '../../../../shared/shared-toolbar-latest';
import Box from '@mui/material/Box';

export default function StepGroupsToolbar() {
  return (
    <Box
      sx={{
        p: 0.5,
        pb: 0,
      }}
    >
      <SharedToolbar noColumn noFilter />
    </Box>
  );
}
